var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sso-loading-container" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "particles" },
      _vm._l(12, function (n) {
        return _c("div", { key: n, staticClass: "particle", class: "p-" + n })
      }),
      0
    ),
    _c("div", { staticClass: "glass-card" }, [
      _c("div", { staticClass: "loader-container" }, [
        _vm._m(1),
        _c("div", { staticClass: "text-area" }, [
          _c("h2", { staticClass: "status-title" }, [
            _vm._v(_vm._s(_vm.loadingText)),
          ]),
          _c("p", { staticClass: "status-subtitle" }, [
            _vm._v(_vm._s(_vm.subtitleText)),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "halo-background" }, [
      _c("div", { staticClass: "orb orb-1" }),
      _c("div", { staticClass: "orb orb-2" }),
      _c("div", { staticClass: "orb orb-3" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cube-loader" }, [
      _c("div", { staticClass: "cube cube1" }),
      _c("div", { staticClass: "cube cube2" }),
      _c("div", { staticClass: "cube cube3" }),
      _c("div", { staticClass: "cube cube4" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }